module.exports = __webpack_public_path__ + "static/80a1b81613038449de9f58e5231dafbf.svg";